import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { balanceApi } from 'helpers/api/balance';

import { Icon } from 'components/Icon';
import { ButtonIcon } from 'components/Button';

import './style.scss';

const CalculatorModal = ({ instrument, disabled, onUpdate, onClose, isFullPledge, setIsFullPledge }) => {
  const [inst, setInst] = useState(null);

  useEffect(() => {
    setInst(instrument);
  }, [instrument]);

  const handleCalculate = () => {
    if (disabled || !inst) {
      return;
    }

    if (!inst.prices) {
      onClose();
      return;
    }

    balanceApi.calculateInstrument(inst).then(({ data } = {}) => {
      onUpdate(data);
    });
  };

  const handleChangePledge = ({ target: { value } }) => {
    if (!inst) {
      return;
    }

    if (inst.prices) {
      const newPrices = inst.prices.slice();
      setInst({
        ...inst,
        pledge: Number(value),
        prices: newPrices.map((item) => ({ ...item, pledge: Number(value) })),
      });
    } else {
      setInst({ ...inst, pledge: value });
    }
  };

  const handleChangePrices = ({ target: { value } }, id) => {
    if (inst?.prices) {
      const priceIndex = inst.prices.findIndex((price) => price.id === id);

      if (priceIndex !== -1) {
        const newPrices = inst.prices.slice();
        newPrices[priceIndex].price = Number(value);
        setInst({ ...inst, prices: newPrices });
      }
    }
  };

  return (
    <>
      <div className="calculator-modal" onClick={(e) => e.preventDefault()}>
        <div className="calculator-header">
          <Icon name="calculator" />
          <span className="button-text">Корректировка цены</span>
        </div>

        <div className="content-spacing">
          <Icon name="instrument" style={{ marginRight: '5px' }} />
          <span>{instrument?.title || ''}</span>
        </div>

        <div className="block-cost">
          <div className="cost-header"></div>
          <div className="cost-header">Цена/сут.</div>
          <div className="cost-header">Залог</div>

          {inst?.prices &&
            inst.prices.map((price, i) => (
              <React.Fragment key={price.id}>
                <div className="cost-title">{price.characteristicName}:</div>
                <input
                  type="number"
                  disabled={disabled}
                  className="cost-input"
                  onChange={(e) => handleChangePrices(e, price.id)}
                  value={price.price || 0}
                />

                {i === 0 ? (
                  <input
                    type="number"
                    disabled={disabled}
                    className="cost-input"
                    onChange={handleChangePledge}
                    value={inst?.pledge || 0}
                  />
                ) : (
                  <div></div>
                )}
              </React.Fragment>
            ))}
        </div>

        <div className="flex-center">
          <ButtonIcon
            className="btn-modal button-bottom"
            style={isFullPledge ? { backgroundColor: 'rgba(229, 255, 198, 1)' } : {}}
            onClick={() => setIsFullPledge(!isFullPledge)}
            icon="shield"
            text="Полный залог"
          />
          <ButtonIcon
            className="btn-modal button-bottom"
            onClick={handleCalculate}
            disabled={disabled}
            icon="save-file"
          />
        </div>
      </div>
      <div className="background-black" onClick={onClose} />
    </>
  );
};

CalculatorModal.propTypes = {
  instrument: PropTypes.object,
  disabled: PropTypes.bool,
  onUpdate: PropTypes.func,
  onClose: PropTypes.func.isRequired,
  isFullPledge: PropTypes.bool,
  setIsFullPledge: PropTypes.func,
};

CalculatorModal.defaultProps = {
  instrument: null,
  disabled: false,
  onUpdate: () => {},
};

export { CalculatorModal };
